import React from "react";
import { useSelector } from "react-redux";
import { View, Text } from "react-native";
import { BoldText } from "components/markdown-text";
import { CheckBox as NativeCheckBox } from "react-native-elements";

import { styles } from "./styles";
import { EmojiHappy, EmojiNeutral, EmojiSad } from "assets/images/emojiSVGs";

export const CheckBox = props => {
  const {
    text,
    styles: propStyles,
    checked,
    representation_type,
    score,
    ...rest
  } = props;
  let { icon = "square" } = props;

  let checkedColor = styles._checkBox?.color;
  const textStyles = [propStyles?.text];

  if (representation_type === "MCO") {
    icon = "happyEmoji";
    if (score === 1) {
      icon = "neutralEmoji";
    } else if (score === 2) {
      icon = "sadEmoji";
    }
  }

  if (props.isCorrect === true) {
    textStyles.push(styles.correctText);
    checkedColor = styles._correctText?.color;
  } else if (props.isCorrect === false && checked) {
    textStyles.push(styles.incorrectText);
    checkedColor = styles._incorrectText?.color;
    icon = "cross";
  }

  const questionnaire = useSelector(state => state.questionnaires[0]);
  const colors = questionnaire.colors;
  const emoji_icon_size =
    questionnaire.config && questionnaire.config.emoji_icon_size;
  const iconType = getIcon(icon, { colors, emoji_icon_size, checked });
  return (
    <NativeCheckBox
      title={<TextView text={text} textStyles={textStyles} />}
      checked={checked}
      checkedColor={checkedColor}
      uncheckedColor={
        representation_type === "RO"
          ? styles._radioBox?.backgroundColor
          : styles._checkBox?.backgroundColor
      }
      containerStyle={styles.chechBoxContainer}
      wrapperStyle={representation_type && styles.wrapperStyleSVG}
      size={propStyles?._checkbox?.fontSize}
      {...iconType}
      {...rest}
    />
  );
};

const TextView = ({ text, textStyles }) => (
  <View style={styles.textview}>
    <Text style={[styles.text, ...textStyles]}>
      <BoldText>{text}</BoldText>
    </Text>
  </View>
);

const getIcon = (type, iconProps) => {
  const ICONS_PROPS = {
    circle: {
      checkedIcon: "check-circle",
      uncheckedIcon: "circle-o",
    },
    square: {
      checkedIcon: "check-square",
      uncheckedIcon: "square-o",
    },
    cross: {
      checkedIcon: "times",
    },
    radioCircle: {
      checkedIcon: "dot-circle-o",
      uncheckedIcon: "circle-o",
    },
    happyEmoji: {
      checkedIcon: <EmojiHappy {...iconProps} />,
      uncheckedIcon: <EmojiHappy {...iconProps} />,
    },
    neutralEmoji: {
      checkedIcon: <EmojiNeutral {...iconProps} />,
      uncheckedIcon: <EmojiNeutral {...iconProps} />,
    },
    sadEmoji: {
      checkedIcon: <EmojiSad {...iconProps} />,
      uncheckedIcon: <EmojiSad {...iconProps} />,
    },
  };

  return ICONS_PROPS[type];
};
